const { recommendRandomSort, formatImage, formatUrl } = require('@ifeng-fe/public_method');

module.exports = {
    jsonParse: data => {
        return JSON.parse(data);
    },
    handleAreaAd: data => {
        return data === '0' ? '' : data;
    },
    handleInfoAd: data => {
        return data.map(item => ({
            img: item.thumbnail && item.thumbnail !== '' ? formatImage(item.thumbnail, 145, 80) : '',
            url: formatUrl(item.url),
            title: item.title,
        }));
    },
    handleRecommend: data => {
        return data.map(item => ({
            base62Id: item.base62Id,
            url: formatUrl(item.url),
            title: item.title,
            commentUrl: item.commentUrl,
            newsTime: item.newsTime,
        }));
    },
    handlePicAndVideo: data => {
        return data.map(item => ({
            img: item.thumbnail && item.thumbnail !== '' ? formatImage(item.thumbnail, 165, 100) : '',
            url: formatUrl(item.url),
            title: item.title,
        }));
    },
    handleNewsList: data => {
        return data.map(item => ({
            img: item.thumbnail && item.thumbnail !== '' ? formatImage(item.thumbnail, 132, 155) : '',
            url: formatUrl(item.url),
            title: item.title,
        }));
    },
    handleLastRecommend: data => {
        return data.map(item => ({
            img: item.thumbnail && item.thumbnail !== '' ? formatImage(item.thumbnail, 222, 156) : '',
            url: formatUrl(item.url),
            title: item.title,
        }));
    },
    handleGoodbookData: data => {
        return recommendRandomSort(data, 8).map(item => ({
            img: item.thumbnail && item.thumbnail !== '' ? formatImage(item.thumbnail, 100, 56) : '',
            url: formatUrl(item.url),
            title: item.title,
        }));
    },
    handleArticleData: data => {
        return data.slice(0, 3).map(item => ({
            type: 'recommend',
            img: item.thumbnail && item.thumbnail !== '' ? formatImage(item.thumbnail, 100, 56) : '',
            url: formatUrl(item.url),
            title: item.title,
        }));
    },
    handleWutonghuiContent: data => {
        return data.slice(0, 2).map(item => ({
            img: item.thumbnail && item.thumbnail !== '' ? formatImage(item.thumbnail, 140, 80) : '',
            url: formatUrl(item.url),
            title: item.title,
        }));
    },
    handleFoVideoData: data => {
        return data.slice(0, 10).map(item => ({
            type: 'recommend',
            img: item.thumbnail && item.thumbnail !== '' ? formatImage(item.thumbnail, 100, 56) : '',
            url: formatUrl(item.url),
            title: item.title,
        }));
    },
    handleVideoData: data => {
        return data.slice(0, 3).map(item => ({
            type: 'recommend',
            img: item.thumbnail && item.thumbnail !== '' ? formatImage(item.thumbnail, 100, 56) : '',
            url: formatUrl(item.url),
            title: item.title,
        }));
    },
    handleHotNewsData: data => {
        return data.slice(0, 2).map(item => ({
            url: formatUrl(item.url),
            title: item.title,
        }));
    },
    handleRecommendArticlesData: data => {
        return data.slice(0, 2).map(item => ({
            img: item.thumbnail && item.thumbnail !== '' ? formatImage(item.thumbnail, 100, 56) : '',
            url: formatUrl(item.url),
            title: item.title,
        }));
    },
    handleHotArticlesData: data => {
        return data.slice(0, 10).map(item => ({
            img: item.thumbnail && item.thumbnail !== '' ? formatImage(item.thumbnail, 100, 56) : '',
            url: formatUrl(item.url),
            title: item.title,
        }));
    },
    handleSubjectData: data => {
        return data.slice(0, 5).map(
            (item, index) =>
                index === 0
                    ? {
                          img: item.thumbnail && item.thumbnail !== '' ? formatImage(item.thumbnail, 270, 105) : '',
                          url: formatUrl(item.url),
                          title: item.title,
                      }
                    : {
                          url: formatUrl(item.url),
                          title: item.title,
                      },
        );
    },
    handleRelatedVideos: data => {
        try {
            data = data.filter(item => {
                return item.type === 'video' || item.type === 'miniVideo';
            });

            return data.slice(0, 20).map((item, index) => ({
                base62Id: item.base62Id,
                guid: item.guid,
                url: item.url,
                title: item.title,
                posterUrl: item.posterUrl,
            }));
        } catch (e) {
            console.error(e);
        }
    },
    handleparentColumn: data => {
        try {
            if (data && data.length > 0) {
                if (data.length > 1) {
                    return data[1].title;
                } else {
                    return '其他';
                }
            } else {
                return '其他';
            }
        } catch (e) {
            console.error(e);
        }
    },
    handleHotTopics: data => {
        try {
            return data.slice(0, 8).map((item, index) => ({
                url: item.url,
                title: item.title,
                img: item.thumbnail && item.thumbnail !== '' ? formatImage(item.thumbnail, 204, 115) : '',
            }));
        } catch (e) {
            console.error(e);
        }
    },
    handleSeoData: data => {
        try {
            let seoData = {};
            let tags = '';

            if (data.tags && typeof data.tags === 'string' && data.tags !== '') {
                tags = JSON.parse(data.tags).map(item => item[0]);
            }

            seoData = {
                keywords: tags ? tags.join(' ') : '',
                description: data.summary,
            };

            return seoData;
        } catch (error) {
            console.error(error);
        }
    },
    handleRecommendVideosData: data => {
        try {
            return data.slice(0, 19).map(item => ({
                base62Id: item.base62Id ? item.base62Id : '',
                pcUrl: item.url,
                posterUrl: item.posterUrl,
                title: item.title,
            }));
        } catch (e) {
            console.error(e);
        }
    },
    handleUnfoldTypeData: data => {
        try {
            return {
                articleUnfold: (data && data.articleUnfold) || '1',
                articleShareUnfold: (data && data.articleShareUnfold) || '1',
                stopReadArticle: (data && data.stopReadArticle) || [],
            };
        } catch (e) {
            console.error(e);
        }
    },
    handleFixedIconData: data => {
        try {
            return {
                image: (data && data.image) || '',
                link: (data && data.link) || '',
                clientLink: (data && data.clientLink) || '',
                topic: (data && data.topic) || '4',
                video: (data && data.video) || '4',
                article: (data && data.article) || '4',
            };
        } catch (e) {
            console.error(e);
        }
    },
};
